/**
 * Stable session id for pre-book funnel telemetry (X-Booking-Session-Id).
 * Optional — backend generates its own correlation id when absent.
 */
const STORAGE_KEY = 'acf_booking_funnel_session_v1';
const HEADER = 'X-Booking-Session-Id';

function _uuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** Return existing session UUID or create and persist one */
export function getOrCreateBookingSessionId() {
  try {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = _uuid();
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return _uuid();
  }
}

/** Start a fresh funnel session (e.g. new search / new itinerary) */
export function resetBookingSessionId() {
  try {
    const id = _uuid();
    sessionStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return _uuid();
  }
}

export const BOOKING_SESSION_HEADER = HEADER;

/** Axios config fragment: { headers: { ... } } */
export function bookingSessionHeaders() {
  return { [HEADER]: getOrCreateBookingSessionId() };
}
